'use client';

import React, { useEffect, useState } from 'react';

export default function ScrollProgress() {
    const [scrollWidth, setScrollWidth] = useState(0);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        setIsMobile(window.innerWidth <= 1024);

        let ticking = false;
        const handleScroll = () => {
            if (!ticking) {
                window.requestAnimationFrame(() => {
                    const totalHeight = document.documentElement.scrollHeight - window.innerHeight;
                    const currentScroll = window.pageYOffset;
                    const scrollPercent = (currentScroll / totalHeight) * 100;
                    setScrollWidth(scrollPercent);
                    ticking = false;
                });
                ticking = true;
            }
        };

        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    if (isMobile) return null;

    return (
        <div className="scroll-progress-container">
            <div
                className="scroll-progress-bar"
                style={{ width: `${scrollWidth}%` }}
            />
        </div>
    );
}
